/** Empty / whitespace invoice notes → null (create/update Joi allow null, ""). */
export function invoiceDescriptionForApi(description?: string | null): string | null {
  return description?.trim() || null;
}
